module.exports = __webpack_public_path__ + "static/img/ios_icon.ff4f4cb5.png";